import script from "./SelectionBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectionBanner.vue?vue&type=script&setup=true&lang=js"

import "./SelectionBanner.vue?vue&type=style&index=0&id=76f85736&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76f85736"]])

export default __exports__